/* eslint-disable react/prop-types */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/sort-comp */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { updateBundleProductPrice, updateBundleProductSelectedOptions } from 'Store/Product/Product.action';
import { ItemOptionsType } from 'Type/ProductList.type';
import { sortBySortOrder } from 'Util/Product';
import {
    bundleOptionsToSelectTransform,
    getEncodedBundleUid,
    nonRequiredRadioOptions
} from 'Util/Product/Transform';

import ProductBundleOption from './ProductBundleOption.component';
import DEFAULT_SORT_FIELD from './ProductBundleOption.config';

/** @namespace Pwa/Component/ProductBundleOption/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    currencyCode: state.ConfigReducer.currencyData.current_currency_code
});

/** @namespace Pwa/Component/ProductBundleOption/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    updateBundleProductSelectedOptions: (options) => dispatch(updateBundleProductSelectedOptions(options)),
    updateBundleProductPrice: (selectedProductData) => dispatch(updateBundleProductPrice(selectedProductData))

});
/**
 * Product Bundle Option
 * @class ProductBundleOptionContainer
 * @namespace Pwa/Component/ProductBundleOption/Container/ProductBundleOptionContainer */
export class ProductBundleOptionContainer extends PureComponent {
    __construct(props) {
        super.__construct(props);
        this.containerFunctions = {
            setQuantity: this.setQuantity.bind(this),
            setActiveSelectUid: this.setActiveSelectUid.bind(this),
            getUidWithQuantity: this.getUidWithQuantity.bind(this),
            getDropdownOptions: this.getDropdownOptions.bind(this),
            setDefaultOption: this.setDefaultOption.bind(this),
            setSelectedBundleOPtions: this.setSelectedBundleOptions.bind(this)
        };
    }

    static propTypes = {
        uid: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        isRequired: PropTypes.bool.isRequired,
        type: PropTypes.string.isRequired,
        options: ItemOptionsType.isRequired,
        updateSelectedValues: PropTypes.func.isRequired,
        currencyCode: PropTypes.string.isRequired
    };

    state = {
        // Is different from UID, due to quantity changing encoding
        activeSelectUid: null,
        quantity: {}
    };

    componentDidMount() {
        const {
            options, option_id, updateBundleProductSelectedOptions, updateBundleProductPrice
        } = this.props;

        this.setDefaultOption();
        const getDefaultOptions = options.filter((option) => option.is_default === true);

        if (getDefaultOptions && getDefaultOptions.length > 0) {
            const { id, quantity, product } = getDefaultOptions[0];

            const optionData = {
                optionId: option_id,
                optionValue: id || null,
                quantity: quantity ?? 1 // fallback to 1 if quantity is undefined or null
            };

            updateBundleProductSelectedOptions(optionData);
            updateBundleProductPrice(product);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { quantity } = this.state;
        const { quantity: prevQuantity } = prevState;

        if (quantity !== prevQuantity) {
            const { updateSelectedValues } = this.props;

            updateSelectedValues();
        }
    }

    setSelectedBundleOptions = (option) => {
        const { optionId, optionValue, quantity } = option;

        // Ensure fallback to an empty array if null/undefined
        const selected = Array.isArray(this.state.selectedBundleOptions)
            ? Array.from(this.state.selectedBundleOptions.map((item) => ({
                id: item.id,
                quantity: item.quantity,
                value: Array.from(item.value)
            })))
            : [];

        const existingIndex = selected.findIndex((item) => item.id === optionId);

        if (existingIndex !== -1) {
            // Existing optionId logic...
            const existing = selected[existingIndex];
            const valueIndex = existing.value.indexOf(String(optionValue));

            if (valueIndex !== -1) {
                existing.value.splice(valueIndex, 1);
            } else {
                existing.value.push(String(optionValue));
            }

            if (existing.value.length > 0) {
                existing.quantity = quantity;
                selected[existingIndex] = existing;
            } else {
                selected.splice(existingIndex, 1);
            }
        } else {
            console.log('🆕 NEW optionId, appending:', optionId);
            selected.push({
                id: optionId,
                quantity,
                value: [String(optionValue)]
            });
        }

        this.setState({ selectedBundleOptions: selected });
    };

    getUidWithQuantity(uid, defaultQuantity = 1) {
        const { quantity: { [uid]: quantity = defaultQuantity } } = this.state;

        return getEncodedBundleUid(uid, quantity);
    }

    setQuantity(uid, value) {
        const { quantity } = this.state;
        const rangedValue = value < 1 ? 1 : value;

        this.setState({
            quantity: {
                ...quantity,
                [uid]: rangedValue
            }
        });
    }

    setActiveSelectUid(uid) {
        this.setState({
            activeSelectUid: uid
        });
    }

    setDefaultOption() {
        const { options } = this.props;

        const [defaultOption = null] = bundleOptionsToSelectTransform(options).filter(({ isDefault }) => isDefault);
        const { isAvailable = false } = defaultOption || {};

        if (defaultOption && isAvailable) {
            this.setActiveSelectUid(defaultOption.value);
        }
    }

    getDropdownOptions() {
        const { options, currencyCode } = this.props;
        const { quantity } = this.state;

        return sortBySortOrder(bundleOptionsToSelectTransform(options, currencyCode, quantity));
    }

    getSortedOptions() {
        const { options = {} } = this.props;

        if (!Array.isArray(options)) {
            return options;
        }

        return sortBySortOrder(options, DEFAULT_SORT_FIELD);
    }

    containerProps() {
        const {
            uid,
            title,
            isRequired,
            type,
            updateSelectedValues,
            currencyCode,
            key,
            option_id
        } = this.props;

        const {
            activeSelectUid,
            quantity
        } = this.state;

        return {
            uid,
            title,
            isRequired,
            type,
            options: nonRequiredRadioOptions(this.getSortedOptions(), isRequired, type),
            updateSelectedValues,
            currencyCode,
            activeSelectUid,
            quantity,
            key,
            option_id
        };
    }

    render() {
        return (
            <ProductBundleOption
              { ...this.props }
              { ...this.state }
              { ...this.containerProps() }
              { ...this.containerFunctions }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductBundleOptionContainer);
